export const UPLOAD_DOCTOR_IMAGE = "UPLOAD_DOCTOR_IMAGE";
export const UPDATE_DOCTOR_INFO = "UPDATE_DOCTOR_INFO";
